import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { exportPriceStatusOptions } from './constants'

const ExportPriceFilter = ({ value, onChange }) => {
  const { t } = useTranslation()

  const menuItems = exportPriceStatusOptions.map(option => ({ label: t(option.label), value: option.value }))

  const handleChange = e => onChange(e.target.value)

  return (
    <ComboBox label={t('Estado')} menuItems={menuItems} value={value} handleChange={handleChange} fullWidth multiple />
  )
}

export default ExportPriceFilter
